// Components
// ---------------------------------------------
import './components/navigation';

// Pages
// ---------------------------------------------
import './page/page-front/gallery';
import './page/page-front/partners';

document.addEventListener('DOMContentLoaded', () => {
	// Initialize Wow.js library
	new WOW({
		animateClass: 'animate__animated',
	}).init();

	// Initialize Fancybox library
	Fancybox.bind('[data-fancybox]', {});
});
